export default "__VITE_ASSET__$qLbw0nj__"